<script lang="ts" setup>
import ThreadsNav from "@/components/mobile/ThreadsNav.vue";
import { computed, onBeforeMount, ref } from "vue";
import { useCoinRank } from "@/stores/coinRank";
import { useRouter } from "vue-router";
import moment from "moment";

const rankStore = useCoinRank();
const router = useRouter();
const historyRankList = computed(() => {
  return rankStore.historyCoinRankList.filter((item) =>
    moment(item.dtStart).isBefore(rankStore.currentCoinRank?.dtStart)
  );
});
const loading = ref(false);
onBeforeMount(async () => {
  loading.value = true;
  try {
    await rankStore.getOrFetchHistoryCoinRank();
  } finally {
    loading.value = false;
  }
});
</script>
<template>
  <div class="h-full grid grid-rows-[auto_1fr]">
    <threads-nav show-back>
      <template #center>
        <div>{{ $t("rank.historyLeaderboard") }}</div>
      </template>
    </threads-nav>
    <div class="overflow-y-auto">
      <div
        v-if="loading"
        class="flex items-center justify-center w-full h-full"
      >
        <span class="loading"></span>
      </div>
      <div v-else class="flex flex-col gap-2 py-2 px-4">
        <div class="text-lg md:text-xl font-bold">{{ $t("rank.onGoing") }}</div>
        <RankListItem
          :rank="rankStore.currentCoinRank!"
          class="bg-primary/80 cursor-pointer text-primary-content"
          @click="
            router.push({
              name: 'rankDetail',
              query: { id: rankStore.currentCoinRank!.id },
            })
          "
        />
        <div class="text-lg md:text-xl font-bold">
          {{ $t("rank.concluded") }}
        </div>
        <div class="flex flex-col gap-1">
          <RankListItem
            v-for="item in historyRankList"
            :key="item.id"
            :rank="item"
            class="cursor-pointer"
            @click="
              router.push({
                name: 'rankDetail',
                query: { id: item.id },
              })
            "
          />
        </div>
      </div>
    </div>
  </div>
</template>
